import { SETTLEMENT_TOKEN_KEY } from "constants/authCred";
import { generateUrlSearchString } from "utils/generateUrlSearchString";

export async function get(url, { headers, params } = {}) {
  return _processRequest({ url, method: "GET", headers, params });
}

export async function post(url, { headers, data }) {
  return _processRequest({ url, method: "POST", headers, body: data });
}

export async function put(url, { headers, data }) {
  return _processRequest({ url, method: "PUT", headers, body: data });
}

export async function patch(url, { headers, data }) {
  return _processRequest({ url, method: "PATCH", headers, body: data });
}

export async function deleteFetch(url, { headers, data }) {
  return _processRequest({ url, method: "DELETE", headers, body: data });
}

const _processRequest = async ({ url, method, headers, body, params }) => {
  const token = sessionStorage.getItem(SETTLEMENT_TOKEN_KEY);

  if (params) {
    url = url + "?" + generateUrlSearchString(params);
  }

  const response = await fetch(url, {
    method,
    headers: {
      ...(Boolean(token) && { Authorization: `Bearer ${token}` }),
      ...headers,
      "Content-Type": "application/json",
    },
    ...(Boolean(body) && { body: JSON.stringify({ ...body }) }),
  });

  if (!response.ok) {
    const res = await response.json();
    const error = new Error(res.message || response.status);
    error["statusCode"] = response.status;
    throw error;
  }

  return response.json();
};
